const queryString = require('query-string');

export const useQuery = (props)=>{
  return queryString.parse(props.location.search);
}
